import { useState } from "react";
import { MdFilterList } from 'react-icons/md';
import { SortDropdown } from "@merchstores/shared/elements/SortDropdown"
import { FilterMenu } from "@merchstores/shared/elements/FilterMenu"
import { ICollectionPageSortFilterProps } from "."
import "./styles.scss"

export const CollectionPageSortFilter: React.FC<ICollectionPageSortFilterProps> = (props: ICollectionPageSortFilterProps) => {

  const { setSortChosen, productFilters, brandFilters, setProductFilterChosen, setBrandFilterChosen, setPriceFilterChosen } = props;
  const [displayFilterMenu, setDisplayFilterMenu] = useState(false)
  
  const sortOptions = [
    {
        title: "Default",
        id: "sort_default",
        action: () => {
          setSortChosen("sort_default")
        }
    },
    {
      title: "Item Name A-Z",
      id: "sort_name_a-z",
      action: () => {
        setSortChosen("sort_name_a-z")
          
      }
  },
  {
    title: "Item Name Z-A",
    id: "sort_name_z-a",
    action: () => {
      setSortChosen("sort_name_z-a")
    }
  },
  {
    title: "Newest",
    id: "sort_newest",
    action: () => {
      setSortChosen("sort_newest")
    }
  },
  {
    title: "Price - Low to High",
    id: "sort_price_low",
    action: () => {
      setSortChosen("sort_price_low")
    }
  },
  {
    title: "Price - High to Low",
    id: "sort_price_high",
    action: () => {
      setSortChosen("sort_price_high")
    }
  },
]

const priceFilterOptions = [
  {
    title: "All",
    id: "all_prices",
    action: () => {
      setPriceFilterChosen({low: 0, high: 5000})
    }
  },
  {
    title: "Under $10.00",
    id: "under_10",
    action: () => {
      setPriceFilterChosen({low: 0, high: 9.99})
    }
  },
  {
      title: "$10.00 - $25.00",
      id: "10-25",
      action: () => {
        setPriceFilterChosen({low: 10, high: 25})
      }
  },
  {
    title: "$25.00 - $50.00",
    id: "25-50",
    action: () => {
      setPriceFilterChosen({low: 25, high: 50})
    }
  },
  {
    title: "$50.00 - $100.00",
    id: "50-100",
    action: () => {
      setPriceFilterChosen({low: 50, high: 100})
    }
  },
  {
    title: "$100 +",
    id: "over_100",
    action: () => {
      setPriceFilterChosen({low: 100, high: 5000})
    }
  },
]

  const onFilterButtonClick = () => {
    setDisplayFilterMenu(!displayFilterMenu)
  }
  

  return (
    <>
    <FilterMenu 
      setProductFilterChosen={setProductFilterChosen}
      setBrandFilterChosen={setBrandFilterChosen}
      productFilters={productFilters} 
      brandFilters={brandFilters}
      priceFilters={priceFilterOptions}
      displayFilterMenu={displayFilterMenu} 
      setDisplayFilterMenu={setDisplayFilterMenu} />
    <div className="w-10/12 mx-auto h-50">
      <div className="w-full flex justify-between lg:px-50">
        <button className={`filter-button text-merch-dark-gray font-bold text-13 rounded-md h-full`} onClick={() => onFilterButtonClick()}>
          <MdFilterList size={20}/>
          <div className="pl-2 cursor-pointer">Filter</div>
        </button>
        
        <SortDropdown title="Sort" list={sortOptions} defaultSort="sort_default"/>
      </div>
    </div>
    </>
  )
}